import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root"
})
export class PowerReviewService {
  private merchantId: string;
  private locale: string;
  private apiKey:string;
  private pid: number;
  private url: string;
  public size: number = 10;
  private sortOrder= "Newest";

  constructor(private _httpClientService: HttpClient) {
      this.url = "https://readservices-b2c.powerreviews.com";
      this.merchantId = "102040";
      this.apiKey = "86803d35-799f-473b-8e2a-b5a2f082a2f3";
      this.size = 10;
      this.locale = "en_US";
      this.sortOrder = 'Newest';
    }

  public callProductSnippetReview(pids): Observable<any> {
    const reqObj = `${this.url}/m/${
      this.merchantId
    }/l/${
      this.locale
    }/product/${pids}/snippet?_nocache=false&_noconfig=false&apikey=${
      this.apiKey
    }`;

    return this._httpClientService.get(reqObj);
  }

  public callProductReview(pid): Observable<any> {
    this.pid = pid;
    const reqObj = `${this.url}/m/${
      this.merchantId
    }/l/${
      this.locale
    }/product/${pid}/reviews?_nocache=false&_noconfig=false&apikey=${
      this.apiKey
    }&paging.size=${this.size}`;

    return this._httpClientService.get(reqObj);
  }

  public callAnotherPage(url): Observable<any> {
    const reqObj =
      `${this.url}${url}&apikey=${this.apiKey}&_noconfig=true&paging.size=${this.size}`;
    return this._httpClientService.get(reqObj);
  }

  public callSortedPage(sortOrder: string): Observable<any> {
    this.sortOrder= sortOrder;
    const reqObj = `https://display.powerreviews.com/m/${
      this.merchantId
    }/l/en_US/product/${
      this.pid
    }/reviews?sort=${sortOrder}&_noconfig=false&apikey=${
      this.apiKey
    }&paging.size=${this.size}`;
    return this._httpClientService.get(reqObj);
  }
}
